<script lang="ts" setup>
import { useModule } from "@/stores/module";
import { RELATION_MODULE_ID } from "@/stores/module/moduleMate";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { showConfirmDialog } from "vant";
import { useMate } from "@/stores/mate";
import { useUI } from "@/stores/ui";
const moduleStore = useModule();
defineProps({
  isSaving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:isSaving"]);
const fields = computed(() => {
  return moduleStore.module!.moduleFieldsMap[RELATION_MODULE_ID];
});

const { t } = useI18n();
const mateStore = useMate();
const updateModule = async () => {
  emit("update:isSaving", true);
  await moduleStore.updateMateModule(RELATION_MODULE_ID);
  emit("update:isSaving", false);
};

const selectedRelationIdx = ref<number>(0);
const uiStore = useUI();
const clickAddRelation = (idx: number) => {
  selectedRelationIdx.value = idx;
  let exclude =
    fields.value[selectedRelationIdx.value].value?.split(",").map(Number) || [];
  exclude.push(mateStore.currentMate!.id!);
  uiStore.popMateSelector({
    mateOnly: true,
    switchMate: false,
    exclude,
    title: t("User.mate.relation.addRelation"),
    callback: (mate) => {
      onSelectMateTrait(mate.id);
      uiStore.showMateSelector = false;
    },
  });
};

const onSelectMateTrait = (mateId: number) => {
  let field = fields.value[selectedRelationIdx.value];
  if (field.value) {
    let set = new Set(field.value.split(","));
    set.add(String(mateId));
    field.value = Array.from(set).join(",");
  } else {
    field.value = String(mateId);
  }
  updateModule();
};

const deleteRelation = (idx: number, mateId: number) => {
  showConfirmDialog({
    title: t("Message.deleteConfirm"),
    confirmButtonText: t("Buttons.confirm"),
    cancelButtonText: t("Buttons.cancel"),
  }).then(() => {
    let field = fields.value[idx];
    let set = new Set(field.value.split(","));
    set.delete(String(mateId));
    field.value = Array.from(set).join(",");
    updateModule();
  });
};

let isInit = ref(false);
onMounted(async () => {
  isInit.value = false;
  console.log(fields.value);
  isInit.value = true;
});
</script>
<template>
  <div class="w-full flex flex-col mt-4">
    <VanCellGroup inset>
      <VanCell v-for="(field, idx) in fields" :key="field.id">
        <div class="flex justify-between items-center">
          <div class="van-field__label flex-1">
            {{ field.displayName }}
          </div>

          <div class="flex gap-2">
            <button
              class="btn btn-xs btn-outline"
              @click="clickAddRelation(idx)"
            >
              <i class="iconify mdi--plus" />
              <!-- <span v-if="field.isPreset">
                {{ $t("User.mate.relation.addRelation") }}
              </span> -->
            </button>

            <button
              class="btn btn-xs btn-outline"
              @click="moduleStore.deleteQuestion(RELATION_MODULE_ID, field.id)"
            >
              <i class="iconify mdi--delete" />
            </button>
          </div>
        </div>
        <div v-if="field.value" class="flex flex-wrap gap-2 py-2">
          <div
            class="w-[60px] relative flex flex-col gap-1 items-center"
            v-for="mateId in field.value.split(',')"
            :key="mateId"
          >
            <button
              class="bg-neutral w-5 h-5 rounded-full flex items-center justify-center absolute top-0 right-0 z-10"
              @click="deleteRelation(idx, Number(mateId))"
            >
              <i class="iconify mdi--close text-xs w-3 text-neutral-content" />
            </button>

            <BaseImg
              :mate="mateStore.mateIdMap.get(Number(mateId))"
              ratio="3:4"
            />
            <div class="text-xs line-clamp-1">
              {{ mateStore.mateIdMap.get(Number(mateId))?.name }}
            </div>
          </div>
        </div>
      </VanCell>
      <CustomModuleEdit
        :module-id="RELATION_MODULE_ID"
        module-name="relationship"
      />
    </VanCellGroup>
  </div>
</template>
